import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAustraliaFlag = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M30.0003 0V29.9994H5.16119e-09C-0.000110031 35.9329 1.75926 41.7331 5.05562 46.6666C8.35198 51.6002 13.0373 55.4454 18.519 57.7162C24.0008 59.9869 30.0328 60.5811 35.8522 59.4236C41.6717 58.2661 47.0172 55.409 51.2129 51.2135C55.4085 47.0179 58.2658 41.6725 59.4235 35.8531C60.5811 30.0336 59.9871 24.0016 57.7165 18.5198C55.4459 13.038 51.6008 8.35258 46.6673 5.05608C41.7339 1.75958 35.9337 5.4645e-05 30.0003 0V0Z",
			fill: "#2A5F9E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.0002 9.99951H10.0001V30.9997H31.0002V9.99951Z",
			fill: "#2A5F9E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.912 6.13892V11.9999H9.60068L24 29.9997H30.0003V22.4999L16.912 6.13892Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.00009 16.9117H3.01252C1.02665 20.9886 -0.00362109 25.4646 9.56246e-06 29.9995H11.9998V11.9116H9.00009V16.9117Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.0002 25.0584L16.9997 8.99951H10.9998L28 29.9994H30.0002V25.0584Z",
			fill: "#ED4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.9119 3.01169V8.99981H9.00009V11.9998H30.0003V8.47401e-06C25.4654 -0.00340845 20.9893 1.02656 16.9119 3.01169Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.0004 2.99976H16.912C10.8481 5.94876 5.94932 10.8476 3.00043 16.9116V29.9994H9.0002V8.99979H30.0004V2.99976Z",
			fill: "#ED4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.5414 31.8474L32.5392 31.8546L32.5414 31.8474Z",
			fill: "#D8A322"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.5372 31.8596L32.5001 31.9387L32.5372 31.8596Z",
			fill: "#D8A322"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.5391 31.8535L32.5372 31.8596L32.5391 31.8535Z",
			fill: "#D8A322"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.2949 33.6367L14.4 38.0119L18.5117 36.1475L15.7792 39.7396L19.8004 41.7924L15.2872 41.8976L16.1891 46.3197L13.2949 42.8567L10.4003 46.3197L11.3034 41.8976L6.79047 41.7924L10.811 39.7396L8.07841 36.1475L12.1886 38.0119L13.2949 33.6367Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.2007 16.6907L46.6712 18.5509L48.4186 17.7587L47.2566 19.2859L48.9658 20.1575L47.0474 20.2029L47.4315 22.0831L46.2007 20.6097L44.9707 22.0831L45.3537 20.2029L43.4367 20.1575L45.1459 19.2859L43.9829 17.7587L45.7307 18.5509L46.2007 16.6907Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.5174 24.3308L54.9871 26.1899L56.7341 25.3977L55.573 26.9256L57.2822 27.7984L55.3629 27.8415L55.7471 29.7229L54.5174 28.2495L53.2866 29.7229L53.6708 27.8415L51.7516 27.7984L53.4607 26.9256L52.2996 25.3977L54.047 26.1899L54.5174 24.3308Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.8453 26.8257L37.3158 28.6855L39.0628 27.8937L37.9016 29.4194L39.6108 30.2925L37.6916 30.3364L38.0757 32.2166L36.8453 30.7436L35.616 32.2166L36.0002 30.3364L34.081 30.2925L35.7901 29.4194L34.629 27.8937L36.3764 28.6855L36.8453 26.8257Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.2007 41.6387L46.6712 43.4973L48.4186 42.7063L47.2566 44.2316L48.9658 45.1047L47.0474 45.1494L47.4315 47.0285L46.2007 45.5585L44.9707 47.0285L45.3537 45.1494L43.4367 45.1047L45.1459 44.2316L43.9829 42.7063L45.7307 43.4973L46.2007 41.6387Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.943 31.9915L50.2931 33.0686H51.4259L50.5084 33.7343L50.8585 34.8126L49.943 34.1469L49.0256 34.8126L49.3764 33.7343L48.4598 33.0686H49.5937L49.943 31.9915Z",
			fill: "white"
		})
	]
});
export default SvgAustraliaFlag;
